import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { receiveToken ,TokenPayload,tempToken,TokenPay} from '../../api/request/tokenThunk';



export interface TokenState {
  token: string;
  slug:string;
  message: string;
  loading: boolean;
  isError: boolean;
  isSuccess:boolean;
  error: string;
  isLogged: boolean;

  tempLoading:boolean;
  tempMessage:string;
  tempError:string;
}

const initialState: TokenState = {
  token:'',
  slug:'',
  isSuccess:false,
  loading: false,
  isError: false,
  error: '',
  message: '',
  isLogged:false,

  tempLoading:false,
  tempMessage:"",
  tempError:"",
};

const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    resetToken: (state) => {
      state.token = '';
      state.isError = false;
      state.error = '';
      state.message='';
      state.isLogged=false;
      state.tempError="";
    },

  },
  extraReducers: (builder) => {
    builder
      .addCase(receiveToken.pending, (state) => {
        state.loading = true;
        state.isError = false;
        state.error = '';
        state.isLogged = false;
      })

      .addCase(receiveToken.fulfilled, (state, action: PayloadAction<TokenPayload>) => {
        state.loading = false;
        state.isSuccess=true;
        state.token = action.payload.data.token;
        state.slug = action.payload.data.slug;
        state.message=action.payload.message; 
        state.isLogged = true;
      })

      .addCase(receiveToken.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.payload as string; 
        state.isLogged = false;
      })



      .addCase(tempToken.pending, (state) => {
        state.tempLoading = true;
      })

      .addCase(tempToken.fulfilled, (state, action: PayloadAction<TokenPay>) => {
        state.tempLoading = false;
        state.tempMessage=action.payload.message; 
      })

      .addCase(tempToken.rejected, (state, action) => {
        state.tempLoading = false;
        state.tempError = action.payload as string; 
      })




      







  },
});

export const {  resetToken } = tokenSlice.actions;
export default tokenSlice.reducer;
